app.service('systemService', function ($http) { 

  // Routes -----------------------------------------
    this.functionCall = function (obj) {
      return $http.post(`/system/server/functionCall`, obj)
        .then(function (response) {
          return response
        })
    }
  //-------------------------------------------------
 
  let userObj = null

  this.setUserObj = (obj) => {
    userObj = obj
  }
  this.getUserObj = () => {
    return userObj
  }

})